module.exports = __webpack_public_path__ + "media/images/lb/216-e5430db8ee00849d066701cad9b8950b.svg";